import {DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions} from 'firebase/firestore';
import {BaseFirebaseModel} from '../bases/baseFirebaseModel';

export class Badge extends BaseFirebaseModel {
	ref: unknown;
	description: string = '';
	date: string = '';
	name: string | number | undefined;
	used: boolean = false;
	private initValue?: Badge;
	private readonly init: boolean = true;

	constructor(obj?: Record<string, unknown>) {
		super();
		if (!this.init) {
			this.init = false;
		} else {
			Object.assign(this, {
				...obj,
				init: false
			});
			this.initValue = {...this};
		}
	}

	_imgUrl: string | undefined;

	get imgUrl(): string {
		if (!this._imgUrl) {
			return 'assets/profil_image.webp';
		}

		return this._imgUrl;
	}

	set imgUrl(url) {
		this._imgUrl = url;
	}

	firestoreUpdate() {
		const update = new Map();
		if (this.initValue) {
			if (this.initValue._imgUrl !== this._imgUrl && this._imgUrl !== undefined) {
				update.set('_imgUrl', this._imgUrl);
			}
			if (this.initValue.date !== this.date && this.date !== undefined) {
				update.set('date', this.date);
			}
			if (this.initValue.name !== this.name && this.name !== undefined) {
				update.set('name', this.name);
			}
			if (this.initValue.description !== this.description && this.description !== undefined) {
				update.set('description', this.description);
			}
		}
		return update;
	}
}

export const badgeConverter: FirestoreDataConverter<Badge, DocumentData> = {
	toFirestore: (badge: Badge): DocumentData => {
		const updateMap = badge.firestoreUpdate();
		const result: Record<string, unknown> = {};
		updateMap.forEach((value, key) => {
			result[key] = value;
		});
		return result as DocumentData;
	},
	fromFirestore: (snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): Badge => {
		const data = snapshot.data(options);
		const badge = new Badge(data);
		badge.uuid = snapshot.id;
		return badge;
	}
};
